/* eslint-disable @typescript-eslint/no-explicit-any */

import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  Button,
  CircularProgress,
} from '@mui/material';
import { Typography } from '@mui/material';
import { BaseAPI } from '@/services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ModelProps } from '@/types';
import { TransitionProps } from '@mui/material/transitions';
import { enqueueSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface Props {
  api: BaseAPI;
  close: () => void;
  text: string;
  id: number;
  modelProps: ModelProps;
}

export function DeletePage(props: Props) {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const mutation = useMutation({
    mutationFn: () => props.api.delete(props.id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [`${props.modelProps.appName}.${props.modelProps.model}`],
      });

      enqueueSnackbar(t('Record deleted successfully.'), {
        variant: 'success',
      });
    },
    onError: (_error: any) => {
      console.log(_error);
      if (_error.response.data.non_field_errors) {
        enqueueSnackbar(_error.response.data.non_field_errors[0], {
          variant: 'error',
        });
      } else {
        enqueueSnackbar(t('Error when trying to delete record'), {
          variant: 'error',
        });
      }
    },
  });

  const submit = async () => {
    props.close();
    mutation.mutate();
  };

  return (
    <div>
      <Dialog
        open
        // onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        keepMounted
        TransitionComponent={Transition}
      >
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h6" color="default">
            {t('Warning')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="subtitle2">
            {t('Do you also want to remove {{text}} with code {{id}}?', {
              text: props.text,
              id: props.id,
            })}
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'space-between' }}>
          <Button
            onClick={props.close}
            variant="contained"
            color="secondary"
            autoFocus
            startIcon={<CloseIcon />}
          >
            {t('Cancel')}
          </Button>
          <Button
            onClick={submit}
            variant="contained"
            color="primary"
            startIcon={!mutation.isPending ? <CheckIcon /> : undefined}
          >
            {!mutation.isPending ? (
              t('Confirmar')
            ) : (
              <CircularProgress size={24} />
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
